"use client"

import { useState } from "react"
import "./MVPfaq.css"

const faqData = [
  {
    question: "What is an MVP?",
    answer:
      "A Minimum Viable Product is a prototype of your product with only the core features so that you can prove it solves a customer problem. It is usually built to validate a business idea, ease the funding process and reduce the development risk.",
  },
  {
    question: "Why should i build an MVP?",
    answer:
      "The majority of the businesses that are developing a new product from scratch have a lot to gain from building an MVP. If you are looking to create a rather complex product with a lot of uncertainty during the business modeling process, an MVP in software will allow you to early test some of the features and validate your assumptions before you invest further in development.",
  },
  {
    question: "What is the MVP approach?",
    answer:
      "There are many ways to plan an MVP project, however, we follow the Scrum approach. The Scrum methodology is a process that aims to deliver small product iterations over time, instead of going through the whole product development in its final version before delivering any value. It is usually related to Agile development practices.",
  },
  {
    question: "MVP vs Prototype vs PoC What is the difference?",
    answer:
      "MVP, Prototype, and Proof of concept (PoC) are three software development methodologies that serve different purposes. An MVP is a product development strategy that focuses on creating a product with the minimum number of features needed to satisfy early users and gather feedback to drive future development. In contrast, a Prototype is an advanced model of a product that is created to evaluate the possible look, feel, and functionality of a product. Finally, a PoC is a preliminary study or demonstration to verify if an idea or concept is feasible and to validate whether it’s possible to develop a full-scale product.Here are some resources that provide you with more detailed information about each of these product development approaches and help you understand their unique characteristics and applications: Minimum Viable Product - Your Guide to building MVPs",
  },
]

const ScopingFAQ = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section541">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT OUR</h1>
          <h2 className="sub-title">MVP SERVICE</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingFAQ;
